import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_have_any_work_areas_w_risk_of_heat_or_cold_stress'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_have_any_work_areas_w_risk_of_heat_or_cold_stress',
  name: 'Does the facility have any work areas with risk of heat or cold stress (extreme hot or cold temperature areas)?',
  description:
    'Heat or cold related stress can occur when the body is unable to warm or cool itself. Heat stress results from a combination of (1) internal body heat production from doing work and (2) external heat exposure from the environment. Cold stress results from being exposed to extreme cold or working in cold environments. Heat and cold stress can contribute to adverse health effects.\r\r\n\r\r\nCommon areas of heat stress may be boiler rooms, outdoor working areas, ovens, etc.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-wor-17',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 16220,
  sectionId: '2.2.9.7',
  impactArea: 'Worker Protection',
  impactAreaId: 'WORKER_PROTECTION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
